import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ADMIN_ROLE_SLUG, OPERATIVE_ROLE_SLUG } from '~/Constants'
import DairyQuery from '~/QueryHooks/DairyQuery'
import Layout from '~/components/Layout'
import TableComponent from '~/components/TableComponent'
import i18n from '~/components/i18n'
import { useAuth } from '~/routes/components/AuthProvider'
import { El as LayoutEl } from '~/components/Layout/style';
import notify from '~/components/Notify'
import Dialog from '~/components/Dialog'
import { Popup } from 'semantic-ui-react'
import CustomIcon from '~/components/CustomIcon'
import CreateEditAssociations from './CreateEditAssociations'

const getTableColumns = () => [
  {
    name: i18n.t('Abbreviation'),
    key: 'abbreviation'
  },
  {
    name: i18n.t('Designation'),
    key: 'name'
  },
  {
    name: i18n.t('Actions')
  }
];

const Associations: React.FC = () => {
  const { t } = useTranslation()
  const { systemData: { logged: { roleSlug } } } = useAuth()
  const displayAction = roleSlug === ADMIN_ROLE_SLUG || roleSlug === OPERATIVE_ROLE_SLUG
  const [drawer, setDrawerState] = useState({
    isVisible: false,
    id: null
  })
  const [selectedType, setSelectedType] = useState(null)
  const actions = [
    {
      popupMessage: i18n.t('Edit'),
      type: 'icon',
      name: 'pencil',
      size: 'large',
      actionType: 'edit',
      displayedText: i18n.t('No actions')
    },
    {
      popupMessage: i18n.t('Delete'),
      type: 'icon',
      name: 'trash',
      size: 'large',
      actionType: 'delete',
      displayedText: i18n.t('No actions'),
      renderActions: getAction
    }
  ]

  function getAction(row, type) {
    return <Popup
      content={t('Delete')}
      trigger={<CustomIcon
        size='large'
        style={{ marginBottom: 2 }}
        onClick={() => setSelectedType(row)}
        name='trash' />}
    />
  }

  const onSuccess = () => {
    notify(t('Successfully deleted association'), 'success');
    fetchData();
  };

  const {
    isLoading: isBusyData,
    data: associations,
    refetch: fetchData
  } = DairyQuery.getAssociationsList()

  useEffect(() => {
    fetchData()
  }, [t])

  const { isLoading: isStateDeleteLoading, mutate: deleteAssociation } = DairyQuery.deleteAssociation(
    onSuccess
  );

  async function onMilkTypeDelete() {
    deleteAssociation(selectedType?.id)
    setSelectedType(null)
  }

  function handleActionClick(row, type) {
    switch (type) {
      case 'edit':
        return setDrawerState({ isVisible: true, id: row?.id })
      default:
        return
    }
  }

  function renderTable() {
    return <TableComponent
      tableColumnHeaders={getTableColumns()}
      rows={rows}
      total={filtered}
      handleClickAction={handleActionClick}
      removePagination
      actions={displayAction ? actions : []}
    />
  }

  function renderActions() {
    return <LayoutEl.PageHeaderActionButton
      onClick={() => setDrawerState({ isVisible: true, id: null })}
    >{t('Add new association')}</LayoutEl.PageHeaderActionButton>
  }

  function renderEditCreateState() {
    return <CreateEditAssociations
      isVisible={drawer.isVisible}
      idAssociation={drawer.id}
      fetchData={fetchData}
      handleHiddenDrawer={() => setDrawerState({ isVisible: false, id: null })}
    />
  }

  function renderDeleteModal() {
    return <Dialog
      key='dialog-assoctiona-type-delete'
      textHeader={t(`Delete association: ${selectedType?.name}`)}
      textClose={t('Close')}
      textContent={t('Are you sure that you want to delete {{association}} association?', { association: selectedType?.name })}
      textSubmit={t('Delete association')}
      handleClose={() => setSelectedType(null)}
      handleSubmit={onMilkTypeDelete}
      type='abort'
      isDialogOpen={Boolean(selectedType)}
      isLoading={isStateDeleteLoading}
    />
  }

  const { filtered, rows } = associations ? associations : { filtered: 0, rows: [] };

  return <Layout
    title={t('Associations')}
    isBusy={isBusyData}
    childContainerSize={'auto'}
    fontSizeHeader={'18px'}
    actions={displayAction && renderActions()}
    useSpinner
  >
    {selectedType && renderDeleteModal()}
    {renderEditCreateState()}
    {associations && renderTable()}
  </Layout>
}
export default Associations